import React, { useState, useEffect } from "react";
import {
  Person as User,
  Lock,
  Visibility as Eye,
  VisibilityOff as EyeOff,
  ArrowForward as ArrowRight,
} from "@mui/icons-material";
import "./Login.css";
import oriensLogo from "../../images/EamLogo2-removebg.png";
import { useNavigate } from "react-router-dom";
import { axiosPrivate } from "../../axios/axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { masterAPI } from "../Masters/dataConfig";
import { SubMenu, isSystemAccess } from "../../ConfigInfo/Info";

// ─── TEMPORARY: PM-Cal menu entries (remove once backend menus include these) ──
const TEMP_PMCAL_CHILDREN = [
  {
    id: "pmcal-temp-000-list",
    module: "pmcal_list",
    href: "/calibration/pm-cal-list",
    name: "PM-Cal List",
    icon: "/imagesIcon/master.png",
    children: null,
    apiRoute: null,
    displayOrder: 0,
    view: true,
    create: true,
    edit: true,
    delete: true,
    openInNewTab: false,
  },
  {
    id: "pmcal-temp-001",
    module: "pmcal_planner",
    href: "/pmcal/planner",
    name: "Planner View",
    icon: "/imagesIcon/master.png",
    children: null,
    apiRoute: null,
    displayOrder: 1,
    view: true,
    create: true,
    edit: true,
    delete: true,
    openInNewTab: false,
  },
  {
    id: "pmcal-temp-002",
    module: "pmcal_approval",
    href: "/pmcal/approval",
    name: "Planner Approval",
    icon: "/imagesIcon/master.png",
    children: null,
    apiRoute: null,
    displayOrder: 2,
    view: true,
    create: true,
    edit: true,
    delete: true,
    openInNewTab: false,
  },
  {
    id: "pmcal-temp-003",
    module: "pmcal_feedback",
    href: "/pmcal/feedback",
    name: "PM-Cal Feedback",
    icon: "/imagesIcon/master.png",
    children: null,
    apiRoute: null,
    displayOrder: 3,
    view: true,
    create: true,
    edit: true,
    delete: true,
    openInNewTab: false,
  },
  {
    id: "pmcal-temp-004",
    module: "pmcal_reports",
    href: "/pmcal/reports",
    name: "Reports",
    icon: "/imagesIcon/master.png",
    children: null,
    apiRoute: null,
    displayOrder: 4,
    view: true,
    create: true,
    edit: true,
    delete: true,
    openInNewTab: false,
  },
];

const TEMP_PMCAL_PARENT = {
  id: "pmcal-temp-000",
  module: "pmcal",
  href: "/pmcal",
  name: "Calibration",
  icon: "/imagesIcon/master.png",
  children: TEMP_PMCAL_CHILDREN,
  apiRoute: "/api/pmcal",
  displayOrder: 11,
  view: true,
  create: true,
  edit: true,
  delete: true,
  openInNewTab: false,
};
// ─── END TEMPORARY ─────────────────────────────────────────────────────────────

// System master menu — only shown for sites where isSystem is true
const filterSystemMenu = (list) =>
  list
    .filter((item) => item.id !== SubMenu.systemMenu)
    .map((item) => ({
      ...item,
      children: item.children ? filterSystemMenu(item.children) : item.children,
    }));

const ModernLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const [errors, setErrors] = useState({});
  const [forgetEmail, setForgetEmail] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuArray = [];

  useEffect(() => {
    dispatch({ type: "loginInfo", payload: {} });
  }, []);

  const menuStructure = (arrayData) => {
    const childData = [];
    if (arrayData.childMenus !== undefined && arrayData.childMenus !== null) {
      arrayData.childMenus.map((dt, i) => {
        const getChildData = menuStructure(dt);
        childData.push(getChildData);
      });
    }

    let structureWithoutChild = {
      id: arrayData.id,
      module: arrayData.module,
      href: arrayData.href,
      name: arrayData.name,
      icon: arrayData.icon,
      children:
        arrayData.childMenus !== undefined &&
        arrayData.childMenus !== null &&
        arrayData.childMenus.length !== 0
          ? childData
          : null,
      apiRoute: arrayData.apiRoute,
      displayOrder: arrayData.displayOrder,
      view: arrayData.view,
      create: arrayData.create,
      edit: arrayData.edit,
      delete: arrayData.delete,
    };
    menuArray.push(structureWithoutChild);
    return structureWithoutChild;
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email is required";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true);
      const loginLink = masterAPI["user"].signin;

      await axiosPrivate
        .post(`${loginLink}`, formData)
        .then((res) => {
          console.log(res);
          dispatch({ type: "loginInfo", payload: res.data.result });
          dispatch({
            type: "drawerOpen",
            payload: { bol: false, open: false },
          });

          const sampleData = res.data.result.menuList;
          const menuData = [];

          for (let i = 0; sampleData.length > i; i++) {
            const finalData = menuStructure(sampleData[i]);
            menuData.push(finalData);
          }

          const hseMenu = {
            id: "000001",
            module: "HSE",
            href: "/hse",
            name: "HSE",
            icon: "/imagesIcon/mainMenu.png",
            children: null,
            apiRoute: "/api/hse",
            displayOrder: 8,
            view: true,
            create: true,
            edit: true,
            delete: true,
          };

          // dispatch({
          //   type: "menuList",
          //   payload:
          //     res.data.result.firstName === "HSCUSER1"
          //       ? [...menuData, hseMenu]
          //       : menuData,
          // });

          // dispatch({
          //   type: "menuArray",
          //   payload:
          //     res.data.result.firstName === "HSCUSER1"
          //       ? [...menuArray, hseMenu]
          //       : menuArray,
          // });

          dispatch({
            type: "subMenuList",
            payload: res.data.result.isSubMenuList,
          });

          const incidentChild = {
            id: "000002-1",
            module: "IM",
            href: "https://hsedemo.orienseam.com/",
            name: "HSE",
            icon: "/imagesIcon/master.png",
            children: null,
            apiRoute: null,
            displayOrder: 1,
            view: true,
            create: true,
            edit: true,
            delete: true,
            openInNewTab: false,
          };

          const incidentManagementParent = {
            id: "000002",
            module: "IM",
            href: "https://hsedemo.orienseam.com/",
            name: "HSE",
            icon: "/imagesIcon/master.png",
            children: [incidentChild],
            apiRoute: "/api/im",
            displayOrder: 9,
            view: true,
            create: true,
            edit: true,
            delete: true,
            openInNewTab: false,
          };

          const pmCalibrationChild = {
            id: "000003-2",
            module: "PM",
            href: "/indexPm.html",
            name: "Calibration",
            icon: "/imagesIcon/master.png",
            children: null,
            apiRoute: null,
            displayOrder: 1,
            view: true,
            create: true,
            edit: true,
            delete: true,
            openInNewTab: true,
          };

          const pmCalibrationParent = {
            id: "000003",
            module: "PM",
            href: "/pm",
            name: "Calibration",
            icon: "/imagesIcon/master.png",
            children: [pmCalibrationChild],
            apiRoute: "/api/pm",
            displayOrder: 10,
            view: true,
            create: true,
            edit: true,
            delete: true,
          };

          const partsReservationMenu = {
            id: "0000012-4",
            module: "inventory_reservation",
            href: "/inventory/reservation",
            name: "Parts Reservation",
            icon: "/imagesIcon/parts.png",
            children: null,
            apiRoute: "",
            displayOrder: 14,
            view: true,
            create: true,
            edit: true,
            delete: true,
          };

          const importMenu = {
            id: "0000013",
            module: "import",
            href: "/import",
            name: "Import",
            icon: "/imagesIcon/master.png",
            children: null,
            apiRoute: "",
            displayOrder: 15,
            view: true,
            create: true,
            edit: true,
            delete: true,
            openInNewTab: false,
          };

          const hardCodeChild = [
            {
              id: "0000012-1",
              module: "masters_stockcat",
              href: "/masters/stockCategory",
              name: "Stock Category",
              icon: "/imagesIcon/master.png",
              children: null,
              apiRoute: null,
              displayOrder: 1,
              view: true,
              create: true,
              edit: true,
              delete: true,
              openInNewTab: false,
            },
            {
              id: "0000012-2",
              module: "masters_department",
              href: "/masters/department",
              name: "Department",
              icon: "/imagesIcon/master.png",
              children: null,
              apiRoute: null,
              displayOrder: 1,
              view: true,
              create: true,
              edit: true,
              delete: true,
              openInNewTab: false,
            },
            {
              id: "0000012-3",
              module: "masters_workflowapproval",
              href: "/workflowapproval",
              name: "Workflow Approval",
              icon: "/imagesIcon/master.png",
              children: null,
              apiRoute: null,
              displayOrder: 1,
              view: true,
              create: true,
              edit: true,
              delete: true,
              openInNewTab: false,
            },
          ];

          const hardCode = {
            id: "0000012",
            module: "hardCode",
            href: "",
            name: "Coded Menus",
            icon: "/imagesIcon/master.png",
            children: [...hardCodeChild, partsReservationMenu, importMenu],
            apiRoute: "",
            displayOrder: 9,
            view: true,
            create: true,
            edit: true,
            delete: true,
            openInNewTab: false,
          };

          // ── TEMPORARY: inject PM-Cal menu for all roles ──────────────────
          // Remove TEMP_PMCAL_PARENT and TEMP_PMCAL_CHILDREN once the backend
          // returns these routes inside res.data.result.menuList
          const isSuperAdmin = res.data.result.roleName === "EAMSUPERADMIN";
          const isSystem = isSystemAccess(res.data.result);

          const menuListPayload = isSuperAdmin
            ? [...menuData, TEMP_PMCAL_PARENT]
            : [...menuData];

          const menuArrayPayload = isSuperAdmin
            ? [...menuArray, ...TEMP_PMCAL_CHILDREN]
            : [...menuArray];

          dispatch({
            type: "menuList",
            payload: isSystem ? menuListPayload : filterSystemMenu(menuListPayload),
          });

          dispatch({
            type: "menuArray",
            payload: isSystem
              ? menuArrayPayload
              : menuArrayPayload.filter((item) => item.id !== SubMenu.systemMenu),
          });

          setLoading(false);
          navigate("/dashboard");
        })
        .catch((e) => {
          setLoading(false);
          // toast.error(e.response.data.failureMessage);
          console.log(e, "login Error");
        });
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleForgetPassword = async () => {
    if (forgetEmail) {
      const forgotlink = masterAPI["user"].forgotEmail;
      try {
        const response = await axiosPrivate.post(`${forgotlink}`, {
          email: forgetEmail,
        });
        console.log("Reset password response:", response.data);
        toast.success(`Password reset link sent to ${forgetEmail}`);
        setOpenDialog(false);
        setForgetEmail("");
      } catch (error) {
        console.error("Error sending reset link:", error);
        toast.error("Failed to send reset link. Please try again.");
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="login-container">
      {/* Animated Background Elements */}
      <div className="login-background">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="grid-pattern"></div>
      </div>

      {/* Login Card with Glow Effect */}
      <div className="login-card-wrapper">
        <div className="login-card-glow"></div>

        <div className="login-card">
          {/* Logo Section */}
          <div className="logo-section">
            <div className="logo-container">
              <img
                src={oriensLogo}
                alt="Oriens EAM Logo"
                className="logo-image"
              />
            </div>
            <h1 className="welcome-title">Welcome Back</h1>
            <p className="welcome-subtitle">
              Enterprise Asset Management System
            </p>
          </div>

          {/* Form Section */}
          <div className="form-section">
            {/* Username Field */}
            <div className="form-group">
              <label className="form-label">Username</label>
              <div className="input-wrapper">
                <div className="input-icon">
                  <User />
                </div>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  className={`form-input ${errors.email ? "error" : ""}`}
                  placeholder=""
                />
              </div>
              {errors.email && <p className="error-message">{errors.email}</p>}
            </div>

            {/* Password Field */}
            <div className="form-group">
              <div className="label-row">
                <label className="form-label">Password</label>
                <button
                  type="button"
                  onClick={() => setOpenDialog(true)}
                  className="forget-password-btn"
                >
                  Forget Password?
                </button>
              </div>
              <div className="input-wrapper">
                <div className="input-icon">
                  <Lock />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  className={`form-input form-input-password ${errors.password ? "error" : ""}`}
                  placeholder=""
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="toggle-password-btn"
                >
                  {showPassword ? <Eye /> : <EyeOff />}
                </button>
              </div>
              {errors.password && (
                <p className="error-message">{errors.password}</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
              className="submit-button"
            >
              {isLoading ? (
                <span>Loading...</span>
              ) : (
                <>
                  <span>SIGN IN</span>
                  <ArrowRight />
                </>
              )}
            </button>

            {/* Contact Support */}
            <div className="contact-support">
              <p className="contact-support-text">
                Need help?{" "}
                <button className="contact-support-btn">Contact Support</button>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Forget Password Dialog */}
      {openDialog && (
        <div className="dialog-overlay">
          <div className="dialog-content">
            <h3 className="dialog-title">Reset Password</h3>
            <div className="dialog-form-group">
              <label className="form-label">Enter your email</label>
              <input
                type="email"
                value={forgetEmail}
                onChange={(e) => setForgetEmail(e.target.value)}
                className="dialog-input"
                placeholder="your.email@example.com"
              />
            </div>
            <div className="dialog-actions">
              <button
                type="button"
                onClick={() => {
                  setOpenDialog(false);
                  setForgetEmail("");
                }}
                className="dialog-button dialog-button-cancel"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleForgetPassword}
                className="dialog-button dialog-button-submit"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModernLogin;
